/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Checkbox, FormControlLabel, Menu, MenuItem } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
function PortsMenu() {

    const location = useLocation();
    const navigate = useNavigate();

    const [selectedPort, setSelectedPort] = useState([]);
    const [anchor, setAnchor] = useState(null);
    const open = Boolean(anchor);
    const [mainData, setMainData] = useState({});
    const formReducer = useSelector((state) => state.form);
  


  

   
    const updateURLQuery = () => {
        if (anchor) {

        const searchParams = new URLSearchParams(location.search);
        if (selectedPort.length === 0) {
            searchParams.delete('Ports');
        } else {
            searchParams.set('Ports', selectedPort.join(','));
        }
        navigate({ search: searchParams.toString() });
    }
    };





    useEffect(() => {
        if (formReducer.loading === 'succeeded') {
            setMainData(formReducer.data);
        }

        const searchParams = new URLSearchParams(location.search);
        const portsParam = searchParams.get('Ports');

        if (portsParam === null) {
            setSelectedPort([]);
        } else {
            const selected = portsParam.split(',').map(Number);
            setSelectedPort(selected);
        }
    }, [formReducer.loading, location.search]);









    useEffect(() => {
        updateURLQuery();
    }, [selectedPort]);




   


    const handleClick = (event) => {


        setAnchor(event.currentTarget);
    };
    const handleClose = (e) => {

        setAnchor(null);
    };

    const handleCheckboxChange = (event) => {
        const portId = Number(event.target.value);
        const isChecked = event.target.checked;

        if (isChecked && portId === 0) {
            setSelectedPort([]);
        } else {
            if (isChecked) {
                setSelectedPort((prevSelected) => [...prevSelected, portId]);
            } else {
                setSelectedPort((prevSelected) => prevSelected.filter((id) => id !== portId));
            }
        }
    };


    return (
        <Box className='Ports'>
            <Box >
                <Button
                    id="Ports"
                    aria-controls={open? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick}

                >
                    Ports
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </Button>
            </Box>
            <Menu
                id="basic-menu"
                anchorEl={anchor}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                PaperProps={{
                    style: {
                        width: '85%',
                        maxWidth: '100%',
                        maxHeight: '300px',
                        left: 0,
                        right: 0,
                    },
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', width: "100%", maxHeight: '300px', overflow: 'auto', overflowY: 'hidden' }}>
                    <MenuItem>
                        <FormControlLabel
                            label="All Ports"
                            control={<Checkbox checked={selectedPort.length === 0} value={0} onChange={handleCheckboxChange} />}
                        />
                    </MenuItem>

                    {mainData.portList?.map((item) => (
                        <MenuItem key={item.id}>
                            <FormControlLabel
                                label={item.name}
                                control={<Checkbox checked={selectedPort.includes(item.id)} value={item.id} onChange={handleCheckboxChange} />}
                            />
                        </MenuItem>
                    ))}
                </Box>
            </Menu>
        </Box>


    )
}

export default PortsMenu